// extracted by mini-css-extract-plugin
export default {"root":"UKVvNCDAFX","root_active":"UxtA7WdyV3","root_hidden":"dItuXIstMa","root_coloredHeader":"LFbnc0RMSH","link":"eZbiQznhb2","container":"UGIoYae5RO","counter":"lUj3I9cvCl"};